<template>
    <Card title="Doações" description="Relatório de Doações" icon="ion ion-ios-document">
        <button @click="$refs.modalDoacoes.open()" class="btn btn-block btn-lg btn-secondary">IR</button>

        <vuestic-modal ref="modalDoacoes" :cancelClass="'none'" :okClass="'none'">
            <div slot="title">Relatório de Doações</div>
            <doacoes></doacoes>
        </vuestic-modal>
    </Card>
</template>

<script>
import Card from '../../../cards/card.vue';
import Doacoes from '../../../relatorios/modal/administrativo/Doacoes.vue'

export default {
    name: 'relatorioAdmin',
    components: {
        Doacoes,
        Card,
    },

    data () {
        return {
        }
    }
}
</script>